module.exports = __webpack_public_path__ + "static/media/contato-banner.7b8cad3b.jpg";